import ProductDetailImage from './ProductDetailImage';
import ProductListImage from './ProductListImage';

const Image = (props) => {
  const {
    product,
    displayType,
    width,
    noImageTag,
    size,
    hasLink = true,
    index
  } = props;

  if (!product.images) {
    return null;
  }
  if (product.images.length === 0) {
    return null;
  }

  switch (displayType) {
    case 'Detail':
      return (
        <ProductDetailImage
          product={product}
          width={width}
          size={size}
          noImageTag={noImageTag}
          index={index}
        />
      );
    case 'Personalization Block':
    case 'Collection':
    case 'List':
      return (
        <ProductListImage
          product={product}
          width={width}
          size={size}
          hasLink={hasLink}
          type={displayType}
          index={index}
        />
      );
    default:
      return null;
  }
};

export default Image;
